import tw from "tailwind-styled-components";

const Card = ({ children }) => {
  return <CardContainer>{children}</CardContainer>;
};
const CardContainer = tw.div` rounded-r-2xl shadow-xl shadow-amber-600 mx-4 md:my-2 w-96 md:mx-0 md:mb-0 md:mb-0 xl:ml-[700px] lg:ml-[500px] md:h-[400px] lg:h-auto  `;
export default Card;
